/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { PageStringSection } from "./pageStringSection";

export class NavigationItems extends PageStringSection {
    text_Home: string = "Labels.lbl_Home";
    text_Calendar: string = "Labels.lbl_Calendar";
    text_Library: string = "Labels.lbl_Library";
    text_MyActivity: string = "Labels.lbl_MyActivity";
    text_Reports: string = "Labels.lbl_Reports";
    text_Analytics: string = "Labels.lbl_Analytics";
    text_Users: string = "Labels.lbl_Users";
    text_Admin: string = "Labels.lbl_Admin";
}
